import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { useNavigate } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import ModalConciliarPago from './ModalConciliarPago';
import PagosTotales from './PagosTotales';
import PagosReferenciasDuplicadas from './PagosReferenciasDuplicadas';
import PagosLista from './PagosLista';

const Pagos = () => {
    const { token, setToken, idCatTipoUsuario } = useToken();
    const { showErrorToast } = useToast();
    const navigate = useNavigate();

    const [vendedores, setVendedores] = useState([]);
    const [cuentas, setCuentas] = useState([]);
    const [mediosPago, setMediosPago] = useState([]);
    const [cargandoCatalogos, setCargandoCatalogos] = useState(true);

    const [showModalConciliar, setShowModalConciliar] = useState(false);
    const [ID_Pago, setID_Pago] = useState(0);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const initialDate = sessionStorage.getItem("selectMes") == null ? new Date() : new Date(sessionStorage.getItem("selectMes"));
    const [dateQuarter, setDateQuarter] = useState(initialDate);
    const [idCatCuentaBancaria, setIdCatCuentaBancaria] = useState(sessionStorage.getItem("ctaBancariaConciliacion") || '');
    const [idCatMedioPago, setIdCatMedioPago] = useState(sessionStorage.getItem("idMedioPago") || '');
    const [idVendedor, setIDVendedor] = useState(sessionStorage.getItem("selectIDUsuario") || '');
    const [filterValidados, setFilterValidados] = useState("-1");
    const [filterStatus, setFilterStatus] = useState("-1");

    const filters = {
        month: (dateQuarter.getMonth() + 1).toString(),
        year: dateQuarter.getFullYear().toString(),
        idCatCuentaBancaria,
        idCatMedioPago,
        idVendedor,
        filterValidados,
        filterStatus
    };

    useEffect(() => {
        if (idCatTipoUsuario != 1) {
            navigate("/");
            return;
        }
        checkPermisos();
    }, []);

    const checkPermisos = async () => {
        const response = await fetch("/api/Administradores/checkPermisos", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response && response.ok) {
            const responseType = await response.json();
            if (responseType.iResponseType == 1) {
                ObtenerCatalogos();
            } else {
                navigate("/");
            }
        } else {
            navigate("/");
        }
    };

    const ObtenerCatalogos = async () => {
        setCargandoCatalogos(true);
        const response = await fetch("/api/AdministracionPagos/ObtenerPagosCatalogos/", {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('' + error.message);
        });

        if (response && response.ok) {
            const objResponse = await response.json();
            if (objResponse.iResponseType == 1) {
                const data = JSON.parse(objResponse.detalles);
                setVendedores(data['table2'] || []);
                setMediosPago(data['table3'] || []);
                setCuentas(data['table4'] || []);
            } else {
                showErrorToast(objResponse.vMessage);
            }
        } else if (response && response.status == 401) {
            setToken(null);
            location.href = "";
        }
        setCargandoCatalogos(false);
    };

    return (
        <>
            <PagosTotales
                filters={filters}
                setID_Pago={setID_Pago}
                setShowModalConciliar={setShowModalConciliar}
            />

            <PagosReferenciasDuplicadas
                filters={filters}
                setID_Pago={setID_Pago}
                setShowModalConciliar={setShowModalConciliar}
                refreshTrigger={refreshTrigger}
            />

            <Card className="mb-3">
                <Card.Header>
                    <Row className="mt-2" style={{ position: 'relative', zIndex: 100 }}>
                        <Col md={12} xs={12} lg={3} className="mb-1">
                            {cargandoCatalogos ? <Skeleton /> : <span><Form.Label className="text-700">Mes</Form.Label> <br /></span>}
                            {cargandoCatalogos ? <Skeleton /> :
                                <DatePicker
                                    selected={dateQuarter}
                                    onChange={(date) => {
                                        sessionStorage.setItem("selectMes", date);
                                        setDateQuarter(date);
                                    }}
                                    dateFormat="MMMM yyyy - QQQ"
                                    className="form-control w-100"
                                    showMonthYearPicker
                                />
                            }
                        </Col>

                        <Col md={12} xs={12} lg={3} className="mb-1">
                            {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700">Vendedores</Form.Label>}
                            {cargandoCatalogos ? <Skeleton /> :
                                <Form.Select
                                    size="sm"
                                    className="form-control"
                                    onChange={(e) => {
                                        setIDVendedor(e.target.value);
                                        sessionStorage.setItem("selectIDUsuario", e.target.value);
                                    }}
                                    value={idVendedor}
                                >
                                    <option value="">Todos los vendedores</option>
                                    {vendedores.map((vendedor, i) => (
                                        <option key={i} value={vendedor.idUsuario}>{vendedor.vNombre + ' ' + vendedor.vApellidos}</option>
                                    ))}
                                </Form.Select>
                            }
                        </Col>

                        <Col md={12} xs={12} lg={3} className="col mb-1">
                            {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700">Cuentas</Form.Label>}
                            {cargandoCatalogos ? <Skeleton /> :
                                <Form.Select
                                    size="sm"
                                    className="form-control"
                                    onChange={(e) => {
                                        setIdCatCuentaBancaria(e.target.value);
                                        sessionStorage.setItem("ctaBancariaConciliacion", e.target.value);
                                    }}
                                    value={idCatCuentaBancaria}
                                >
                                    <option value="">Todas las cuentas</option>
                                    {cuentas.map((cta, i) => (
                                        <option key={i} value={cta.idCatCuentaBancaria}>{cta.vNumCta}-{cta.vAlias}</option>
                                    ))}
                                </Form.Select>
                            }
                        </Col>

                        <Col md={12} xs={12} lg={3} className="col mb-1">
                            {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700">Medio de Pagos</Form.Label>}
                            {cargandoCatalogos ? <Skeleton /> :
                                <Form.Select
                                    size="sm"
                                    onChange={(e) => {
                                        setIdCatMedioPago(e.target.value);
                                        sessionStorage.setItem("idMedioPago", e.target.value);
                                    }}
                                    value={idCatMedioPago}
                                >
                                    <option value="">Todos los medios de Pago</option>
                                    {mediosPago.map((medioPago, i) => (
                                        <option key={i} value={medioPago.idCatMedioPago}>{medioPago.idCatMedioPago}-{medioPago.vMedioPago}</option>
                                    ))}
                                </Form.Select>
                            }
                        </Col>
                    </Row>

                    <Row className="mt-1">
                        <Col className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-sm-4 col-6">
                            <Form>
                                {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700 fs--2">Validados</Form.Label>}
                                {cargandoCatalogos ? <Skeleton /> :
                                    <Form.Select
                                        size="sm"
                                        className="form-control"
                                        onChange={(e) => {
                                            setFilterValidados(e.target.value);
                                        }}
                                        value={filterValidados}
                                    >
                                        <option value="-1">TODOS</option>
                                        <option value="1">Validados</option>
                                        <option value="0">No Validados</option>
                                    </Form.Select>
                                }
                            </Form>
                        </Col>

                        <Col className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-sm-4 col-6">
                            <Form>
                                {cargandoCatalogos ? <Skeleton /> : <Form.Label className="text-700 fs--2">Estatus</Form.Label>}
                                {cargandoCatalogos ? <Skeleton /> :
                                    <Form.Select
                                        size="sm"
                                        className="form-control"
                                        onChange={(e) => {
                                            setFilterStatus(e.target.value);
                                        }}
                                        value={filterStatus}
                                    >
                                        <option value="-1">TODOS</option>
                                        <option value="1">Activos</option>
                                        <option value="0">Cancelados</option>
                                    </Form.Select>
                                }
                            </Form>
                        </Col>
                    </Row>
                </Card.Header>
                <PagosLista
                    filters={filters}
                    setID_Pago={setID_Pago}
                    setShowModalConciliar={setShowModalConciliar}
                />
            </Card>

            {showModalConciliar &&
                <ModalConciliarPago
                    showModalConciliar={showModalConciliar}
                    setShowModalConciliar={setShowModalConciliar}
                    idPago={ID_Pago}
                    onPagoActualizado={() => setRefreshTrigger(prev => prev + 1)}
                />
            }
        </>
    );
};

export default Pagos;
